import config from 'message-control/config'

const newJavaApi = `${config.apiHost}/oem-crm_new_java`

export default {
    list: {
        url: `${newJavaApi}/api/risk-management/sensitive-word-notice`,
        type: 'GET',
    },
    update: {
        url: `${newJavaApi}/api/risk-management/sensitive-word-notice`,
        type: 'POST',
    },
}
